import { PureLightTheme } from "../../../styles/theme"

export const CardItem = {
  maxWidth: '736px',
  width: '100%',
  cursor: 'pointer',
}

export const TypDescriptionOne = {
  display: '-webkit-box',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 3,
  marginBottom: '15px',
  [PureLightTheme.breakpoints.down('sm')]: {
    marginBottom: 1,
  },
}
